<template>
  <f7-page>
    <f7-navbar :title="user | userName" :back-link="$t('action.back')">
      <f7-subnavbar v-if="!isMyProfile">
        <f7-segmented>
          <f7-button tab-link :tab-link-active="showCard" @click="showCard = true">{{$t('title.userCard', {user:
            user.firstName})}}
          </f7-button>
          <f7-button tab-link :tab-link-active="!showCard" @click="showCard = false">{{$t('title.info')}}</f7-button>
        </f7-segmented>
      </f7-subnavbar>
    </f7-navbar>
    <div v-if="showCard">
      <f7-block-title v-html="$t('title.cardStatus.title', {status: $t(`title.cardStatus.${card.status}`)})"/>
      <div v-if="!isPending">
        <f7-block>
          <f7-row>
            <f7-col>
              <f7-button fill :href="`${links.cardTransfer}/${user.id}`" color="blue" :disabled="!hasMoney">
                {{$t('action.cardTransfer')}}
              </f7-button>
            </f7-col>
            <f7-col>
              <f7-button fill @click="freezeCard(user.id)" v-if="card.status === 'Active'">Freeze card</f7-button>
              <f7-button fill @click="unfreezeCard(user.id)" v-if="card.status === 'Suspended'">Unfreeze card
              </f7-button>
              <span v-if="card.suspendedBy && (card.suspendedBy === user.id)">{{`Frozen by ${userName(user)}`}}</span>
            </f7-col>
          </f7-row>
        </f7-block>
        <f7-list>
          <f7-list-item :title="$t('label.balance')" :after="formatMoney(card.currency, card.balance)"/>
        </f7-list>
      </div>
      <f7-block v-else>{{$t('title.noCard', {user: this.userName(user)})}}</f7-block>
      <transaction-list v-if="!isPending" :transactions="transactions"/>
    </div>
    <div v-else>
      <f7-list form>
        <f7-list-item divider :title="$t('title.userDetails')"/>
        <f7-list-input :label="$t('label.email')"
                       type="text"
                       :value="user.email"
                       disabled
        />
        <f7-list-input :label="$t('label.firstName')"
                       type="text"
                       :value="user.firstName"
                       disabled
        />
        <f7-list-input :label="$t('label.lastName')"
                       type="text"
                       :value="user.lastName"
                       disabled
        />
        <f7-list-input :label="$t('label.dob')"
                       type="text"
                       :value="user.dob | toDate"
                       disabled
        />
        <f7-list-input :label="$t('label.phone')"
                       type="text"
                       :value="user.phone"
                       disabled
        />
        <f7-list-item v-if="user.address" divider :title="$t('label.address')"/>
        <f7-list-input v-if="user.address"
                       :label="$t('label.address')"
                       type="text"
                       :value="user.address.addressLine1"
                       disabled
        />
        <f7-list-item v-if="user.address && user.address.addressLine2">
          <f7-input type="text" :value="user.address.addressLine2.trim()" disabled/>
        </f7-list-item>
        <f7-list-input v-if="user.address"
                       :label="$t('label.location')"
                       type="text"
                       :value="user.address.city"
                       disabled
        />
        <f7-list-input v-if="user.address"
                       :label="$t('label.postcode')"
                       type="text"
                       :value="user.address.postcode"
                       disabled
        />
      </f7-list>
    </div>
  </f7-page>
</template>

<script>
  import api from 'aio-api'
  import helpers from '@/utils/helpers'
  import TransactionList from '../components/transaction-list'

  export default {
    name: 'user-page',
    components: {
      TransactionList,
    },
    computed: {
      isPending () {
        return this.card.status === 'pending'
      },
      isMyProfile () {
        return this.$f7route.path === this.links.profile
      },
      hasMoney () {
        return this.card.balance > 0
      },
      user () {
        if (this.isMyProfile) {
          return this.currentUser
        }
        return this.$store.getters.getUser(this.$f7route.params.id)
      },
    },
    async created () {
      if (!this.isMyProfile) {
        this.showCard = true
        this.getCard()
        this.getExpenses()
      }
      this.$bus.on('transaction-update', this.getExpenses)
      this.$bus.on('card-update', this.getCard)
    },
    data () {
      return {
        card: {},
        showCard: false,
        transactions: [],
      }
    },
    methods: {
      async getCard () {
        this.card = await api.getCard(this.user.id)
      },
      async getExpenses () {
        this.transactions = await api.getExpenses(this.user.id)
        this.transactions.sort(this.sortExpenses)
      },
      freezeCard (userId) {
        this.$f7.dialog.confirm(`Are you sure you want to freeze ${this.user.firstName}'s card? They won't be able to use it for any purchases while frozen.`, '', async () => {
          await api.freezeCard(userId)
          this.$bus.$emit('card-update')
        })
      },
      async unfreezeCard (userId) {
        await api.unfreezeCard(userId)
        this.$bus.$emit('card-update')
      },
    },
    mixins: [helpers],
  }
</script>

<style lang="scss" scoped>
  @import '@/sass/variables.scss';

  .block-title /deep/ {
    text-align: center;
    text-transform: none !important;

    b {
      color: $cyan;
      text-transform: uppercase;
    }
  }
</style>
